import React from "react";

const Partners = () => {
  // Sample partner data - replace with your actual partners
  const partners = [
    {
      id: 1,
      name: "TechCorp",
      logo: "TC",
      description: "Leading technology partner",
    },
    {
      id: 2,
      name: "EduMax",
      logo: "EM",
      description: "Educational excellence",
    },
    {
      id: 3,
      name: "LearnHub",
      logo: "LH",
      description: "Learning innovation",
    },
    {
      id: 5,
      name: "BrainBoost",
      logo: "BB",
      description: "Cognitive enhancement",
    },
   
  ];

  return (
    <section className="relative py-20 px-4 overflow-hidden bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_40%,rgba(120,119,198,0.3),transparent_50%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_60%,rgba(168,85,247,0.2),transparent_50%)]"></div>

      {/* Floating Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-24 h-24 bg-gradient-to-r from-pink-500/20 to-orange-500/20 rounded-full blur-xl animate-pulse delay-1000"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-6">
            <div className="w-2 h-2 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full animate-pulse"></div>
            <span className="text-white/80 text-sm font-medium">
              Trusted Partners
            </span>
          </div>

          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Empowering Education
            <span className="block bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
              Together
            </span>
          </h2>

          <p className="text-xl text-white/70 max-w-3xl mx-auto leading-relaxed">
            We collaborate with industry leaders and educational innovators to
            create the most comprehensive learning ecosystem for tutors and
            students worldwide.
          </p>
        </div>

        {/* Partners Grid */}
        <div className="relative">
          {/* Animated Border */}
          <div className="absolute inset-0 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-3xl opacity-20 animate-pulse"></div>
          <div className="absolute inset-[2px] bg-slate-900/80 backdrop-blur-sm rounded-3xl"></div>

          <div className="relative p-8 md:p-12">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              {partners.map((partner, index) => (
                <div
                  key={partner.id}
                  className="group relative"
                  style={{
                    animationDelay: `${index * 100}ms`,
                  }}>
                  {/* Partner Card */}
                  <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 transition-all duration-500 hover:bg-white/10 hover:border-white/20 hover:scale-105 hover:-translate-y-2 group-hover:shadow-2xl group-hover:shadow-purple-500/20">
                    {/* Hover Glow Effect */}
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-xl"></div>

                    {/* Logo */}
                    <div className="relative z-10 flex items-center justify-center mb-4">
                      <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center text-white font-bold text-lg shadow-lg group-hover:shadow-blue-500/30 transition-all duration-300">
                        {partner.logo}
                      </div>
                    </div>

                    {/* Partner Info */}
                    <div className="relative z-10 text-center">
                      <h3 className="text-white font-semibold text-lg mb-2 group-hover:text-blue-300 transition-colors duration-300">
                        {partner.name}
                      </h3>
                      <p className="text-white/60 text-sm group-hover:text-white/80 transition-colors duration-300">
                        {partner.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            { number: "50+", label: "Global Partners", icon: "🌍" },
            { number: "1M+", label: "Students Reached", icon: "🎓" },
            { number: "99%", label: "Success Rate", icon: "⭐" },
          ].map((stat, index) => (
            <div
              key={index}
              className="text-center p-6 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl hover:bg-white/10 transition-all duration-300 group">
              <div className="text-4xl mb-3 group-hover:scale-110 transition-transform duration-300">
                {stat.icon}
              </div>
              <div className="text-3xl md:text-4xl font-bold text-white group-hover:text-blue-300 transition-colors duration-300">
                {stat.number}
              </div>
              <div className="text-white/70 font-medium mt-2">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <div className="inline-flex flex-col sm:flex-row gap-4">
            <button className="group relative px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-xl hover:from-blue-500 hover:to-purple-500 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-blue-500/30">
              <span className="relative z-10">Become a Partner</span>
              <div className="absolute inset-0 bg-white/20 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>

            <button className="group px-8 py-4 border-2 border-white/20 text-white font-semibold rounded-xl hover:border-white/40 hover:bg-white/5 transition-all duration-300 hover:scale-105">
              View All Partners
              <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300 inline-block">
                →
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
